import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ProductAPIDataSource} from '../api';
import {useNotificationStore} from '../../notifications/store/notificationStore';
import {LoggerService} from '../../../Services/common/LoggerService';

import StandardizedErrorHandler from '../../../Services/common/StandardizedErrorHandler';

export const useProductOperations = () => {
  const queryClient = useQueryClient();

  // Helper function to show notifications from Zustand store
  const showSuccess = (message: string) => {
    useNotificationStore.getState().addNotification({
      type: 'success',
      message,
      duration: 3000
    });
  };

  const deleteProduct = useMutation({
    mutationFn: async (productId: number) => {
      LoggerService.userAction('Delete Product', {productId});
      const response = await ProductAPIDataSource.deleteProduct(productId);
      return response;
    },
    onSuccess: () => {
      // Invalidate and refetch products data
      queryClient.invalidateQueries({queryKey: ['products']});

      // Show success notification
      showSuccess('تم حذف المنتج بنجاح');

      LoggerService.info('Product deleted successfully');
    },
    onError: (error: unknown) => {
      StandardizedErrorHandler.getInstance().handleError(error);
      LoggerService.error('Failed to delete product', error, 'useProductOperations');
    }
  });

  const addStock = useMutation({
    mutationFn: async (data: { productId: number; quantity: number }) => {
      LoggerService.userAction('Add Stock', data);
      // Add stock logic here when API is available
      return data;
    },
    onSuccess: (data) => {
      // Invalidate inventory related queries
      queryClient.invalidateQueries({queryKey: ['products']});
      queryClient.invalidateQueries({queryKey: ['inventory']});

      showSuccess('تم إضافة المخزون بنجاح');
      LoggerService.info('Stock added successfully', data);
    },
    onError: (error: unknown) => {
      StandardizedErrorHandler.getInstance().handleError(error);
      LoggerService.error('Failed to add stock', error, 'useProductOperations');
    }
  });

  return {
    deleteProduct,
    addStock,
    isDeleting: deleteProduct.isPending,
    isAddingStock: addStock.isPending
  };
};
